module.exports = __webpack_public_path__ + "img/main_pic2.0f25e1b2.jpg";